export default {
  'survey.action.back_home': '会員センターへ戻る',
  'survey.cta.register': '今すぐ会員登録',
  'survey.cta.view_coupon': 'マイクーポンを見る',
  'survey.cta.view_points': 'マイポイントを見る',
  'survey.cta.go_member_center': '会員センターへ',
  'survey.cta.go_member_card': '会員カードへ',
  'survey.cta.go_coupon': 'クーポン一覧へ',
  'survey.cta.register_to_claim': '登録して受け取る 🎁',
  'survey.cta.join_member': '会員登録する！',
  'survey.welcome.question_count': '{count} 問',
  'survey.welcome.estimated_minutes': '約 {minutes} 分',
  'survey.welcome.start': '回答を開始',
  'survey.welcome.privacy':
    '回答するとプライバシーポリシーに同意したものとみなされます',
  'survey.welcome.privacy_prefix': '回答すると同意したものとみなされます：',
  'survey.reward.title': 'あなた専用の特典',
  'survey.reward.member_points': '会員ポイント',
  'survey.reward.point_unit': 'ポイント',
  'survey.reward.points': '{points} ポイント',
  'survey.reward.coupon': '{name}{qty}',
  'survey.reward.coupon_fallback': 'クーポン',
  'survey.reward.require_member': '会員登録すると特典を受け取れます',
  'survey.question.unsupported': 'この設問タイプは現在サポートされていません',
  'survey.question.auth_required':
    'アンケートを送信する前に LINE ログインを完了してください。',
  'survey.question.submit_failed':
    '送信に失敗しました。しばらくしてからもう一度お試しください。',
  'survey.question.required': '必須',
  'survey.footer.submitting': '送信中...',
  'survey.footer.submit': '送信',
  'survey.footer.next': '次へ',
  'survey.footer.back': '前へ',
  'survey.progress.label': '質問 {current}/{total}',
  'survey.district.city': '都道府県・市区町村',
  'survey.district.city_placeholder': '地域を選択してください',
  'survey.district.township': '行政区',
  'survey.district.township_placeholder': '行政区を選択してください',
  'survey.text.placeholder': '回答を入力してください...',
  'survey.multi_choice.selected_count': '{count} 件選択済み',
  'survey.rating.1': '非常に不満',
  'survey.rating.2': '不満',
  'survey.rating.3': '普通',
  'survey.rating.4': '満足',
  'survey.rating.5': '非常に満足',
  'survey.rating.aria_label': '{score} 点、{label}',
  'survey.rating.placeholder': '評価を選択してください',
  'survey.complete.thanks': 'ご回答ありがとうございました！',
  'survey.complete.submitted': 'アンケートを送信しました。',
  'survey.error.SVY001.title': 'アンケートが見つかりません',
  'survey.error.SVY001.content':
    'このアンケートは存在しないか、削除されています。',
  'survey.error.SVY002.title': 'このアンケートは現在回答できません',
  'survey.error.SVY002.content':
    'アンケートリンクをご確認いただくか、しばらくしてからもう一度お試しください。',
  'survey.error.SVY003.not_started.title':
    'このアンケートはまだ開始していません',
  'survey.error.SVY003.not_started.content': '{date} に開始予定です。',
  'survey.error.SVY003.ended.title': 'このアンケートは終了しました',
  'survey.error.SVY003.ended.content': '回答期限は {date} まででした。',
  'survey.error.SVY003.title': 'このアンケートは未開始または終了しています',
  'survey.error.SVY003.content': 'アンケートの公開期間をご確認ください。',
  'survey.error.SVY009.title': 'この招待は期限切れです',
  'survey.error.SVY009.content': 'ご関心をお寄せいただきありがとうございます。',
  'survey.error.SVY010.title': 'このリンクはあなたのものではありません',
  'survey.error.SVY010.content': 'このアンケートリンクでは回答できません。',
  'survey.error.SVYF009.title': 'この店舗は一時的にサービスを停止しています',
  'survey.error.SVYF009.content':
    '別の店舗のアンケートリンクをご利用いただくか、しばらくしてからもう一度お試しください。',
  'survey.error.E001.title': 'アンケートリンクが無効です',
  'survey.error.E001.content':
    '完全なアンケートリンクを開いているかご確認ください。',
  'survey.error.auth_required.title': 'アンケートを開けません',
  'survey.error.auth_required.content':
    'アンケートを開く前に LINE ログインを完了してください。',
  'survey.error.default.title': 'アンケートを開けません',
  'survey.error.default.content':
    'アンケートの確認に失敗しました。しばらくしてからもう一度お試しください。',
  'survey.filled.title': 'このアンケートにはすでに回答済みです',
  'survey.filled.content':
    'このアンケートは一度のみ回答できます。ご参加ありがとうございました。',
  'survey.filled.recent.content':
    '{completedDate}に回答済みです。次回は{nextOpenDate}から回答できます。',
} as Record<string, string>;
